<template>
  <v-dialog ref="menu"
            v-model="showDatePicker"
            :return-value.sync="date"
            persistent
            width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field :outlined="!readonly"
                    :append-icon="readonly ? null: 'fas fa-calendar-day'"
                    :label="label"
                    :placeholder="label"
                    v-model="dateString"
                    readonly
                    :hide-details="hideDetails"
                    v-on="readonly ? null : on"
                    :rules="rules"></v-text-field>
    </template>
    <v-date-picker v-model="pickerDate"
                   :range="range"
                   scrollable>
      <v-btn text color="primary" @click="showDatePicker = false">Cancel</v-btn>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="clearDate">Clear</v-btn>
      <v-btn text color="primary" @click="$refs.menu.save(pickerDate)">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import {computed, ref, watch} from "@vue/composition-api";

export default {
  name: 'DatePickerInput',
  props: {
    value: [String, Array],
    label: String,
    range: Boolean,
    readonly: Boolean,
    hideDetails: [Boolean, String],
    rules: Array,
  },
  setup(props, {root, emit}) {
    const date = ref(props.value || (props.range ? [] : null));
    const pickerDate = ref(props.value || (props.range ? [] : null));
    const dateString = computed(() => {
      return props.range ? (pickerDate.value.length === 2 ? `${pickerDate.value[0]} - ${pickerDate.value[1]}` : '') : pickerDate.value;
    })
    const clearDate = function () {
      // date.value = (props.range ? [] : null);
      pickerDate.value = (props.range ? [] : null);
      // showDatePicker.value = false;
    };
    watch(
        date,
        (newVal, oldVal) => {
          if (newVal !== oldVal) {
            emit('input', newVal)
          }
        }
    );
    watch(() => props.value, (newValue) => {
      if (newValue) {
        date.value = newValue;
        pickerDate.value = newValue;
      } else {
        date.value = props.range ? [] : null;
        pickerDate.value = props.range ? [] : null;
      }
    });

    const showDatePicker = ref(false);

    return {
      date,
      pickerDate,
      dateString,
      showDatePicker,
      clearDate,
    }
  }
}
</script>
